import React, {useEffect, useState} from "react";
import { Link, useParams } from "react-router-dom";
import {
    API_VARSEL_BEKREFT_PATH,
} from "../../../constants/urls";
import {useNameMapping} from "../../../context/NameMappingContext";
import styles from "./varselConfirm.module.css";
import "../../../styles/App.css";
import {CircularProgress} from "@material-ui/core";
import ErrorPage from "../errorPage/ErrorPage";
import StaticSearchChips from "../chips/StaticSearchChips";
import SakFilter from "../SakFilter";
import {createUrl} from "../../../utils/utils";
import {QUERY_PARAMS} from "../../../constants/enum";

type VarselData = {
    svarfrist: string[];
    saksnivaa: string[];
    fylker: number[];
    kommuner: number[];
    epost: string;
    fritekst: string | null;
};

const VarselConfirm = () => {

    const { id } = useParams<{ id: string }>();

    const loadingContext = useNameMapping().isLoading;
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [varselFound, setVarselFound] = useState(false);
    const [varselFilter, setVarselFilter] = useState<SakFilter>();
    const [filterUrl, setFilterUrl] = useState<String>();

    useEffect(() => {
        setIsLoading(true);
        console.log("id: " + id);
        fetch(API_VARSEL_BEKREFT_PATH + id, {
            method: "POST",
        })
            .then(async (res) => {
                if (!res.ok) {
                    console.log("Not ok: ", res.status);
                    if (res.status === 404) {
                        return null;
                    }
                    throw new Error(`HTTP ${res.status}`);
                }
                return res.json();
            })
            .then((varselData: VarselData) => {
                if (varselData == null) {
                    setVarselFound(false);
                } else {
                    setVarselFound(true);

                    setVarselFilter(
                        new SakFilter(
                            varselData.saksnivaa,
                            varselData.fylker,
                            varselData.kommuner,
                            varselData.svarfrist,
                            varselData.fritekst
                        )
                    );

                    const url = createUrl({
                        [QUERY_PARAMS.SVARFRIST]: varselData.svarfrist,
                        [QUERY_PARAMS.SAKSNIVAA]: varselData.saksnivaa,
                        [QUERY_PARAMS.FYLKE]: varselData.fylker.map((n) =>
                            n.toString()
                        ),
                        [QUERY_PARAMS.KOMMUNE]: varselData.kommuner.map((n) =>
                            n.toString()
                        ),
                        [QUERY_PARAMS.FRITEKST]: varselData.fritekst
                            ? [varselData.fritekst]
                            : [],
                    });
                    setFilterUrl(url);
                }
            })
            .then(() => {
                setIsLoading(false);
            })
            .catch((err) => {
                console.log("Catching ", err);
                setError(true);
                setIsLoading(false);
                console.log(error);
            });

    }, [id]);

    if (error) {
        return <ErrorPage />;
    }
    if (isLoading || loadingContext) {
        return <CircularProgress />;
    }

    return (
        <div className={styles.varselMain}>
            <div className={styles.content}>
                <h1 className="main-heading">Bekreftelse</h1>
                {varselFound ? (
                    <div className={styles.content}>
                        <p>
                            Takk for at du aktiverte abonnementet ditt!
                            <br />
                            Du blir varslet på epost for nye og endrede saker
                            basert på filteret:
                        </p>

                        {varselFilter && (
                            <StaticSearchChips filter={varselFilter} />
                        )}

                        {filterUrl && (
                            <p>
                                <Link to={`/${filterUrl}`}>Se sakene</Link>
                            </p>
                        )}
                    </div>
                ) : (
                    <p>Abonnement for bekreftelse ikke funnet</p>
                )}
            </div>
        </div>
    );
};

export default VarselConfirm;
